import { motion } from 'framer-motion';
import { FiBookOpen, FiMapPin } from 'react-icons/fi';
import SectionHeading from './SectionHeading';
import { SiteConfig } from '../types/portfolio';
import Icon from './Icon';

type EducationSectionProps = {
  education: SiteConfig['education'];
};

function EducationSection({ education }: EducationSectionProps) {
  return (
    <section id="education" className="section-shell">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <SectionHeading
          eyebrow="Education"
          title="Academic foundation supporting practical engineering delivery."
          description="The portfolio keeps education concise while preserving the professional and enterprise-grade tone of the overall presentation."
        />

        <motion.article
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.5 }}
          className="glass-panel rounded-[2rem] p-8"
        >
          <div className="flex flex-wrap items-start justify-between gap-6">
            <div>
              <div className="flex items-center gap-3 text-sky-200">
                <Icon icon={FiBookOpen} />
                <span className="text-sm font-semibold uppercase tracking-[0.3em]">Degree</span>
              </div>
              <h3 className="mt-4 text-2xl font-semibold text-white">{education.degree}</h3>
              <p className="mt-3 text-base text-slate-300">{education.college}</p>
            </div>
            <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 text-sm text-slate-200">
              <Icon icon={FiMapPin} className="text-sky-300" />
              {education.location}
            </div>
          </div>
        </motion.article>
      </div>
    </section>
  );
}

export default EducationSection;
